////////////////////////////////////////////////////////////////////////////////////////////////////
//
// The ObjectFunc class 
// @version 0.0.2.0
// @created-date 2014.04.25
// @modified-date 2015.12.06
// @author beach.li
//
// @changes 0.0.2.0 (2015.12.06)
// Support the clone object method via the cloneObject.
// Specially, it should support the native JSON class from the browser.
//
////////////////////////////////////////////////////////////////////////////////////////////////////
const ClassFunc = require('@/tbs/util/ClassFunc')
//--------------------------------------------------
// construtor
//--------------------------------------------------
var tbs_util_ObjectFunc = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_util_ObjectFunc.prototype = {
	//--------------------------------------------------
	// static api
	//--------------------------------------------------
    /**
	 * @api
	 * Parse the pair string.
	 * The pair string is something like "name1=value1&name2=value2&...".
	 * Return the pair object {name1:value1, name2:value2, ...}
	 * @param pairString The pair string.
	 * @return The pair object.
	 */
	parsePairString: function(pairString) {
		var pairObject = {};

		if (!pairString) {
			return pairObject
		}

		var pairs = pairString.split("&");
		for (var i = 0; i < pairs.length; i++) {
			var pair = pairs[i];
			var pv = pair.split("=");
			if (pv.length == 2) {
				// @tmp Regarding the url case, ask the url encoded.
				// decode url anyway now
				// @todo Need more validate on this one.
				pairObject[pv[0]] = decodeURIComponent(pv[1]);
			}
			else {
				pairObject[pv[0]] = "";
			}
		}
		return pairObject;
	},
	/**
     * @api
     * Clone the object via JSON Serialization and deSerialization.
     * Use stringify method to convert object to string.
     * Use parse method to convert string to object.
     * @param source The source object.
     * @return The cloned object.
     */
    cloneObject(source) {
        let cloned;
        if (source && JSON && JSON.stringify && JSON.parse) {
            cloned = JSON.parse(JSON.stringify(source));
        }
        return cloned;
    },
    /**
     * @api
     * Compare the objects via JSON Serialization.
     * Use stringify method to convert object to string,
     * and compare the string value as the result.
     * @param source The source object.
     * @param target The target object.
     * @return The compare boolean result.
     */
    compareObjects: function(source, target) {
        if (JSON && JSON.stringify) {
            var srcStr = JSON.stringify(source);
            var tarStr = JSON.stringify(target);
            if (srcStr == tarStr) {
                return true;
            }
        }
        return false;
    },
    mergeObject: function(source, obj, keepSource) {
        if (source && obj) {
            for (var prop in obj) {
                if (source[prop] && typeof(obj[prop]) == "object" && !this.isEmpty(obj[prop])) {
                    this.mergeObject(source[prop], obj[prop]);
                }
                else {
                    if (obj[prop] != null) {
                        source[prop] = obj[prop];
                    }
                    else {
                        if (!keepSource) {
                            source[prop] = null;
                            delete source[prop];
                        }
                    }
                }	
            }
        }
        else if (obj && !source) {
            source = obj;
        }
        return source;
    },
    /**
     * @api
     * Complete the value with the certain separator. 
     * Convert the value object into the String.
     * Use the padStart method to complete the separator units.
     * @param value The value object.
     * @param length The restrict length number.
     * @param separator The separator unit and '0' as default.
     * @return The padded string.
     */
    pad: function(value, length, separator) {
        separator = separator || '0'
        return value.toString().padStart(length, separator)
    },
    mergePathUrl: function(prefix, path, suffix) {
        let url = ''
        prefix = prefix || ''
        path = path || ''
        url += prefix + path
        if (suffix) {
            let joinSignal
            if (path.indexOf('?') > -1) {
                joinSignal = '&'
            }
            else {
                joinSignal = '?'
            }
            url += joinSignal + suffix
        }
        // console.log('@url', url)
        return url
    },
    capitalizeFirstLetter: function(str) {
        if (!str) {
            return ''
        }
        return str.charAt(0).toUpperCase() + str.slice(1)
    },
    hasObjectPropertyByPath: function(obj, path) {
        if (!path) {
            return false
        }
        obj = this.cloneObject(obj)
        if (path.indexOf('.') == -1) {
            return obj['hasOwnProperty'](path)
        }
        // treat the '.' as property getter 
        var pathArr = path.split('.')
        var fetchedObj = obj
        for (let i = 0; i < pathArr.length; i++) {
            const pathItem = pathArr[i]
            if (pathItem) {
                if (fetchedObj['hasOwnProperty'](pathItem)) {
                    fetchedObj = fetchedObj[pathItem]
                }
                else {
                    return false
                }
            }
        }
        return true
    },
    getObjectPropertyByPath: function(obj, path) {
        // console.log('getObjectPropertyByPath', obj, path)
        if (!path) {
            return obj
        }
        if (path.indexOf('.') == -1) {
            return obj[path]
        }
        // treat the '.' as property getter 
        var pathArr = path.split('.')
        var fetchedObj = obj
        for (let i = 0; i < pathArr.length; i++) {
            if (fetchedObj) {
                const pathItem = pathArr[i]
                if (pathItem) {
                    fetchedObj = fetchedObj[pathItem]
                }
            }     
        }
        return fetchedObj
    },
    extractPropertiesFromObject: function(object, props) {
        props = props || []
        object = object || {}
        let item = {}
        for (let i = 0; i < props.length; i++) {
            let prop = props[i]
            item[prop] = object[prop] ? this.cloneObject(object[prop]) : null
        }
        return item
    },
    extractPropertiesFromArray: function(array, props) {
        props = props || []
        array = array || []
        let container = []
        for (let i = 0; i < array.length; i++) {
            let object = array[i]
            container.push(this.extractPropertiesFromObject(object, props))
        }
        return container
    },
    extractProperties: function(object, props) {
        if (ClassFunc.getClass(object) == 'Array') {
            // array condition
            return this.extractPropertiesFromArray(object, props)
        }
        else if (ClassFunc.getClass(object) == 'Object') {
            // object condition
            return this.extractPropertiesFromObject(object, props)
        }
    },
    /**
     * @api
     * Check the object is null or empty.
     */
    isEmpty: function(obj) {
        if (!obj) {
            return true;
        }

        for (var p in obj) {
            if (obj[p]) {
                return false;
            }
        }
        return true;
    },
    mergeArray: function(source, refer, sourceKey, referKey, selectedFields) {
        const merged = []
        selectedFields = selectedFields || []
        for (let i = 0; i < source.length; i++) {
            let srcItem = source[i]
            let hit = false
            for (let j = 0; j < refer.length; j++) {
                let refItem = refer[j]
                if (srcItem[sourceKey] == refItem[referKey]) {
                    const mergedItem = {}
                    for (let p in srcItem) {
                        if (selectedFields.indexOf(p) > -1) {
                            mergedItem[p] = refItem[p] ? refItem[p] : srcItem[p]
                        }
                    }
                    for (let p in refItem) {
                        if (selectedFields.indexOf(p) > -1) {
                            mergedItem[p] = refItem[p] ? refItem[p] : srcItem[p]
                        }
                    }
                    merged.push(mergedItem)
                    hit = true
                    break
                }
            }
            if (!hit) {
                const mergedItem = {}
                for (let p in srcItem) {
                    if (selectedFields.indexOf(p) > -1) {
                        mergedItem[p] = srcItem[p]
                    }
                }
                merged.push(mergedItem)
            }
        }
        return merged
    },
    convertSelectedItemArray2String: function(items, prop, separator) {
        prop = prop || 'label'
        separator = separator || ','
        items = items || []
        const selectedItems = []
        for (let i = 0; i < items.length; i++) {
            let item = items[i]
            if (item.selected) {
                selectedItems.push(item[prop])
            }
        }
        return selectedItems.join(separator)
    },
};

/**
 * The static implementation approach
 * @return The static method.
 */
var instance;
if (!instance) {
	instance = new tbs_util_ObjectFunc;
}

module.exports = instance;